module.exports = __webpack_public_path__ + "img/avatar_3.6fdab716.png";